"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var part_description_1 = require("./part-description");

var surfaceFactor = {
  white: 1,
  granite: {
    'black': 1.15,
    'black-white': 1.15,
    'light-gray': 1.15
  }
};
exports.surcharge = {
  surfaceFactor: surfaceFactor
};
exports.exchangeRates = {
  EUR: 1,
  CHF: 1.15,
  CZK: 25.53,
  PLN: 4.3
}; // Loops through all prices, to get the one which fits the size

exports.getPriceForSize = function (prices, size) {
  var foundPrice = 0;

  for (var _i = 0, _a = Object.keys(prices); _i < _a.length; _i++) {
    var key = _a[_i];
    var limit = Number(key);
    var price = prices[key];

    if (size <= limit) {
      foundPrice = price;
      break;
    }
  }

  ;
  return foundPrice;
};

exports.getCutOutPrice = function (type, items, isoCode) {
  switch (type) {
    case 'ROUND_SLEEVE':
    case 'ROUND_BASKET':
    case 'ROUND_SLEEVE_BASKET':
      return exports.getValueFromPricings(items, 'cutout_disposal_sleeve', isoCode);

    case 'SQUARE_SLEEVE':
    case 'SQUARE_BASKET':
    case 'SQUARE_SLEEVE_BASKET':
    case 'FLAP_BASKET':
      return exports.getValueFromPricings(items, 'cutout_disposal_sleeve', isoCode);

    case 'ROUND_RAIL':
    case 'SQUARE_RAIL':
    case 'FLAP_RAIL':
    case 'SQUARE_SLEEVE_RAIL':
    case 'ROUND_SLEEVE_RAIL':
      return exports.getValueFromPricings(items, 'cutout_waste_rail', isoCode);
    // Rail system

    case 'FLAP':
    case 'CUSTOM_ROUND':
    case 'CUSTOM_SQUARE':
      return exports.getValueFromPricings(items, 'cutout_individual', isoCode);

    default:
      return 0;
  }
}; // export const validIsoCodes = ['DE','RU','LT','LV','EE','HU','RO','UA','BG','SI','HR','RS','BA','SK','CZ','PL','BE','LU','NL','AT','PT','MT','IL','CY','ES','CH','IT','FR','IC1','IC2'];


exports.isoDetails = {
  de: {
    isoCode: 'de',
    name: 'Germany',
    priceList: 'DE',
    salesOrganization: 1010,
    salesOffice: 1010,
    vatFactor: 1.19,
    saleFactor: 2.9,
    freightFactor: 1.1834,
    isValidMarket: true // Used to determine if the prices can be edited and therefore sold for this market... if set to false, then the isoDetail may not be used (I think I need to confirm later)

  },
  ru: {
    isoCode: 'ru',
    name: 'Russia',
    priceList: 'E5',
    salesOrganization: 1010,
    salesOffice: 1030,
    vatFactor: 1.20,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: false
  },
  lt: {
    isoCode: 'lt',
    name: 'Lithuania',
    priceList: 'E2',
    salesOrganization: 1010,
    salesOffice: 1030,
    vatFactor: 1.21,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: false
  },
  lv: {
    isoCode: 'lv',
    name: 'Latvia',
    priceList: 'E2',
    salesOrganization: 1010,
    salesOffice: 1030,
    vatFactor: 1.21,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: false
  },
  ee: {
    isoCode: 'ee',
    name: 'Estonia',
    priceList: 'E2',
    salesOrganization: 1010,
    salesOffice: 1030,
    vatFactor: 1.20,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: false
  },
  hu: {
    isoCode: 'hu',
    name: 'Hungary',
    priceList: 'HU',
    salesOrganization: 1010,
    salesOffice: 1030,
    vatFactor: 1.27,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: false
  },
  ro: {
    isoCode: 'ro',
    name: 'Romania',
    priceList: 'E4',
    salesOrganization: 1010,
    salesOffice: 1030,
    vatFactor: 1.19,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: false
  },
  ua: {
    isoCode: 'ua',
    name: 'Ukraine',
    priceList: 'UA',
    salesOrganization: 1010,
    salesOffice: 1030,
    vatFactor: 1.20,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: false
  },
  bg: {
    isoCode: 'bg',
    name: 'Bulgaria',
    priceList: 'E2',
    salesOrganization: 1010,
    salesOffice: 1030,
    vatFactor: 1.20,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: false
  },
  si: {
    isoCode: 'si',
    name: 'Slovenia',
    priceList: 'E7',
    salesOrganization: 1010,
    salesOffice: 1030,
    vatFactor: 1.22,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: false
  },
  hr: {
    isoCode: 'hr',
    name: 'Croatia',
    priceList: 'E2',
    salesOrganization: 1010,
    salesOffice: 1030,
    vatFactor: 1.25,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: false
  },
  rs: {
    isoCode: 'rs',
    name: 'Serbia',
    priceList: 'CS',
    salesOrganization: 1010,
    salesOffice: 1030,
    vatFactor: 1.20,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: false
  },
  ba: {
    isoCode: 'ba',
    name: 'Bosnia and Herzegovina',
    priceList: 'E2',
    salesOrganization: 1010,
    salesOffice: 1030,
    vatFactor: 1.17,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: false
  },
  sk: {
    isoCode: 'sk',
    name: 'Slovakia',
    priceList: 'E6',
    salesOrganization: 1010,
    salesOffice: 1030,
    vatFactor: 1.20,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: false
  },
  cz: {
    isoCode: 'cz',
    name: 'Czechia',
    priceList: 'CZ',
    salesOrganization: 1010,
    salesOffice: 1030,
    vatFactor: 1.21,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: false
  },
  pl: {
    isoCode: 'pl',
    name: 'Poland',
    priceList: 'E3',
    salesOrganization: 1010,
    salesOffice: 1030,
    vatFactor: 1.23,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: true
  },
  be: {
    isoCode: 'be',
    name: 'Belgium',
    priceList: 'BE',
    salesOrganization: 1010,
    salesOffice: 1040,
    vatFactor: 1.21,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: false
  },
  lu: {
    isoCode: 'lu',
    name: 'Luxembourg',
    priceList: 'E2',
    salesOrganization: 1010,
    salesOffice: 1030,
    vatFactor: 1.17,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: false
  },
  nl: {
    isoCode: 'nl',
    name: 'Netherlands',
    priceList: 'NE',
    salesOrganization: 1010,
    salesOffice: 1040,
    vatFactor: 1.21,
    saleFactor: 2.9,
    freightFactor: 1,
    isValidMarket: false
  },
  at: {
    isoCode: 'at',
    name: 'Austria',
    priceList: 'AT',
    salesOrganization: 3910,
    salesOffice: 3910,
    vatFactor: 1.20,
    saleFactor: 3,
    freightFactor: 1.1157,
    isValidMarket: true
  },
  pt: {
    isoCode: 'pt',
    name: 'Portugal',
    priceList: 'E2',
    salesOrganization: 3910,
    salesOffice: 3911,
    vatFactor: 1.23,
    saleFactor: 2.8,
    freightFactor: 1,
    isValidMarket: false
  },
  mt: {
    isoCode: 'mt',
    name: 'Malta',
    priceList: 'E2',
    salesOrganization: 3910,
    salesOffice: 3911,
    vatFactor: 1.18,
    saleFactor: 2.8,
    freightFactor: 1,
    isValidMarket: false
  },
  il: {
    isoCode: 'il',
    name: 'Israel',
    priceList: 'E2',
    salesOrganization: 3910,
    salesOffice: 3911,
    vatFactor: 1.18,
    saleFactor: 2.8,
    freightFactor: 1,
    isValidMarket: false
  },
  cy: {
    isoCode: 'cy',
    name: 'Cyprus',
    priceList: 'E2',
    salesOrganization: 3910,
    salesOffice: 3911,
    vatFactor: 1.19,
    saleFactor: 2.8,
    freightFactor: 1,
    isValidMarket: false
  },
  es: {
    isoCode: 'es',
    name: 'Spain',
    priceList: 'ES',
    salesOrganization: 3910,
    salesOffice: 3914,
    vatFactor: 1.21,
    saleFactor: 2.8,
    freightFactor: 1,
    isValidMarket: false
  },
  ch: {
    isoCode: 'ch',
    name: 'Switzerland',
    priceList: 'CH',
    salesOrganization: 3910,
    salesOffice: 3915,
    vatFactor: 1.077,
    saleFactor: 3.5,
    freightFactor: 1.1157,
    isValidMarket: true
  },
  it: {
    isoCode: 'it',
    name: 'Italy',
    priceList: 'IT',
    salesOrganization: 3910,
    salesOffice: 3912,
    vatFactor: 1.22,
    saleFactor: 2.55,
    freightFactor: 1,
    isValidMarket: false
  },
  fr: {
    isoCode: 'fr',
    name: 'France',
    priceList: 'FR',
    salesOrganization: 3910,
    salesOffice: 3913,
    vatFactor: 1.20,
    saleFactor: 2.8,
    freightFactor: 1,
    isValidMarket: false
  },
  ic1: {
    isoCode: 'ic1',
    name: 'IC1',
    priceList: 'DE',
    salesOrganization: 1010,
    salesOffice: 1010,
    vatFactor: 1,
    saleFactor: 1.08,
    freightFactor: 1,
    isValidMarket: false
  },
  ic2: {
    isoCode: 'ic2',
    name: 'IC2',
    priceList: 'AT',
    salesOrganization: 3910,
    salesOffice: 3910,
    vatFactor: 1,
    saleFactor: 1.08,
    freightFactor: 1,
    isValidMarket: false
  }
};
exports.isoDetailsArray = Object.entries(exports.isoDetails);

exports.getValueFromPricings = function (pricings, id, groupKey, allowFallback, dateWrap) {
  if (groupKey === void 0) {
    groupKey = 'de';
  }

  if (allowFallback === void 0) {
    allowFallback = true;
  }

  if (!pricings || !pricings.items || !pricings.items.find || !id) {
    return 0;
  }

  var items = pricings.items;
  groupKey = groupKey.toLowerCase();
  var partPricing = items.find(function (i) {
    return i.groupKey === groupKey && i.key === id;
  });

  if (!partPricing && allowFallback) {
    partPricing = items.find(function (i) {
      return i.groupKey === 'de' && i.key === id;
    });
  }

  if (!partPricing && allowFallback) {
    partPricing = items.find(function (i) {
      return i.key === id;
    });
  }

  if (!partPricing) {
    return 0;
  }

  var itemType = part_description_1.getPartDetail(id, 'type', 'de', false, pricings.type); // TODO... this needs to have dynamic 'market'... or just pass in the whole pricings not just the items

  var value = partPricing.value; // Market period

  if (dateWrap && pricings.type === 'market' && pricings.timePeriods) {
    for (var _i = 0, _a = pricings.timePeriods; _i < _a.length; _i++) {
      var period = _a[_i];
      if (!(id in period) || !period[id]) continue;
      var from = new Date(period.dateFrom).getTime();
      var until = new Date(period.dateUntil).getTime();

      if (dateWrap.from <= from && dateWrap.until >= until) {
        value = period[id];
      }
    }
  }

  if (itemType) {
    if (itemType === 'float' || itemType === 'price' || itemType === 'percentage') {
      value = parseFloat(value);
    }

    if (itemType === 'percentage') {
      value = value / 100 + 1; // Factors are stored as percentages (eg. 5, instead of 1.05 for 5% increase), so have to make it work with existing code
    }
  }

  return value;
};

exports.getValueFromPricingsUpTo = function (pricings, id, value, groupKey) {
  if (groupKey === void 0) {
    groupKey = 'de';
  }

  if (!pricings || !pricings.items || !id) {
    return 0;
  }

  var items = pricings.items;
  groupKey = groupKey.toLowerCase();
  var partPricing;
  var partPricings = items.filter(function (i) {
    return i.groupKey === groupKey && i.key.startsWith(id);
  });

  if (partPricings.length === 0) {
    partPricings = items.filter(function (i) {
      return i.groupKey === 'de' && i.key.startsWith(id);
    });
  }

  if (partPricings.length === 0) {
    return 0;
  }

  try {
    for (var _i = 0, partPricings_1 = partPricings; _i < partPricings_1.length; _i++) {
      var partPrice = partPricings_1[_i];
      var upto = Number(partPrice.key.replace(id, ''));

      if (value <= upto && !partPricing) {
        partPricing = partPrice;
      }
    }
  } catch (e) {
    return 0;
  }

  if (!partPricing || isNaN(partPricing.value)) return 0;
  return parseFloat(partPricing.value);
};

exports.getMarketByCountryCode = function (pricings, countryCode) {
  if (pricings === void 0) {
    pricings = [];
  }

  if (countryCode === void 0) {
    countryCode = 'de-DE';
  }

  var marketPricings = pricings.filter(function (pricing) {
    return pricing.type === 'market' && !pricing.deleted && !pricing.paused;
  });

  var getPricingByCountry = function getPricingByCountry(code) {
    return marketPricings.find(function (pricing) {
      var countryPair = pricing.items.find(function (i) {
        return i.key === 'country';
      });
      return countryPair && countryPair.value === code || false;
    }) || null;
  };

  return getPricingByCountry(countryCode) || getPricingByCountry('de-DE');
};

exports.getNestedPricingProp = function (pricings, key) {
  if (pricings === void 0) {
    pricings = [];
  }

  var availablePricings = pricings.filter(function (pricing) {
    return !pricing.deleted;
  }) || [];
  var nestedValues = availablePricings.map(function (p) {
    var country = p.items.find(function (i) {
      return i.key === key;
    });
    return country && country.value;
  });
  return nestedValues;
};